module.exports = __webpack_public_path__ + "static/media/taskDescription.fdc2f85e.svg";